import { z } from 'zod';

const dateRange = z.object({
  from: z.date().optional(),
  to: z.date().optional(),
});

export const formSchema = z.object({
  material: z.string().optional(),
  plannerId: z.string().optional(),
  materialDescription: z.string().optional(),
  batch: z.string().optional(),
  productReasonTypeId: z.string().optional(),
  totalValue: z.string().optional(),
  shelfLifeExpirationDate: z.string().optional(),
  storageLocation: z.string().optional(),
  priority: z.array(z.string()).optional(),
  destinationPlant: z.string().optional(),
  deliveryForecastDate: dateRange.optional(),
});

export type FormSchema = z.infer<typeof formSchema>;